import ComponentEditor from './ComponentEditor';
export default ComponentEditor;
